import React, { Dispatch, FunctionComponent } from 'react';
import Slider from '../inputs/Slider';
import TextInput from '../inputs/TextInput';
import PageWrapper from '../layout/PageWrapper';
import { Header, InputBox, InputRow } from './SoldPriceHeader.style';

interface Props {
  query: string;
  setQuery: Dispatch<string>;
  radius: number;
  setRadius: Dispatch<number>;
}

const SoldPriceHeader: FunctionComponent<Props> = (props) => {
  return (
    <>
      <Header>
        <h1>PROPERTY PRICE REGISTER</h1>
      </Header>

      <InputBox>
        <PageWrapper>
          <InputRow>
            <TextInput
              name="query-text-input"
              label="SEARCH NEAR"
              placeholder="Town e.g. 'Donegal'"
              value={props.query}
              onValueChange={props.setQuery}
              testID="query-text-input"
            />

            <Slider
              appendix="kms"
              disabled={props.query === ''}
              label="RADIUS"
              value={props.radius}
              maxValue={40}
              onValueChange={props.setRadius}
            />
          </InputRow>
        </PageWrapper>
      </InputBox>
    </>
  );
};

export default SoldPriceHeader;
